import { Platform } from 'react-native';

const SKIP_TOUR_KEY = 'flowsoft_skip_voice_onboarding_tour';

export function isTourDismissed(): boolean {
  if (Platform.OS !== 'web') return false;
  try {
    return localStorage.getItem(SKIP_TOUR_KEY) === 'true';
  } catch {
    return false;
  }
}

export function dismissTour(): void {
  if (Platform.OS !== 'web') return;
  try {
    localStorage.setItem(SKIP_TOUR_KEY, 'true');
  } catch {
    // localStorage may be unavailable (private mode / quota); silently ignore.
  }
}

export function resetTour(): void {
  if (Platform.OS !== 'web') return;
  try {
    localStorage.removeItem(SKIP_TOUR_KEY);
  } catch {
    // localStorage may be unavailable (private mode / quota); silently ignore.
  }
}
